import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// CDK
import { MatButtonModule } from '@angular/material/button';

// Components
import { NotPageFoundComponent } from '@views/public/404/not-page-found.component';
import { UnauthorizedComponent } from '@views/public/401/unauthorized.component';



@NgModule({
  declarations: [
    NotPageFoundComponent,
    UnauthorizedComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
  ]
})
export class PublicModule { }
